import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import type TasApplicationModel from 'tio-data/models/tas-application';
import type RouterService from '@ember/routing/router-service';

export interface DetailWithIconArgs {
  Args: {
    application?: TasApplicationModel;
  };
  Element: HTMLElement;
}

export default class FullHistory extends Component<DetailWithIconArgs> {
  @service declare router: RouterService;

  goToHistory = () => {
    const element = document.getElementById('app-history');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      const app = this.args.application;
      this.router.transitionTo('authenticated.tas.applications.history', app?.id);
    }
  };
  <template>
    <div class="p-2 cursor-pointer border-t tio-border-default">
      <button class="tio-fg-disabled" type="button" {{on "click" this.goToHistory}}>
        {{t "common.progress_tracker.full_history"}}
      </button>
    </div>
  </template>
}
